import { ScrollArea } from "@unfiddle/ui/components/scroll-area"
import { cn } from "@unfiddle/ui/utils"

export function Main({
   children,
   className,
   innerClassName,
}: {
   children?: React.ReactNode
   className?: string
   innerClassName?: string
}) {
   return (
      <main
         className={cn(
            "flex h-[calc(100svh-var(--bottom-navigation-height))] grow overflow-hidden bg-background md:mt-2 md:mr-2 md:h-[calc(100svh-16px)] md:grow md:rounded-lg md:border md:border-surface-12/13 md:shadow-xs",
            className,
         )}
      >
         <div className={cn("relative flex grow flex-col", innerClassName)}>
            {children}
         </div>
      </main>
   )
}

interface Props extends React.ComponentProps<typeof ScrollArea> {
   containerClassName?: string
   container?: boolean
}

export function MainScrollArea({
   children,
   className,
   containerClassName,
   container = true,
   ...props
}: Props) {
   return (
      <ScrollArea
         className={cn(
            "flex flex-col pt-4 lg:pt-5",
            container ? "pb-14" : "",
            className,
         )}
         {...props}
      >
         <div
            className={cn(
               "flex grow flex-col",
               container ? "container" : "",
               containerClassName,
            )}
         >
            {children}
         </div>
      </ScrollArea>
   )
}
